import React from 'react';
import moment from 'moment';
import { get } from 'lodash';

export default class DetailRow extends React.Component {
  /*constructor(props) {
    super(props);
  }*/

  renderState(state){
    if(state === 'available'){
      return(<strong className="btn-badge s-good">Exist</strong>)
    }else if(state === 'unconfirmed'){
      return '-'
    }
  }

  details() {
    if(window.ReactNativeWebView){
      const {RowData} = this.props;
      window.ReactNativeWebView.postMessage(JSON.stringify(
        { 
          type: 'AssetDetail', data: get(RowData, 'Asset.Alias')
        }
        ));
    }
  }

  render() {
    const {RowData} = this.props

    return (
      <tr onClick={()=>this.details()}>
        <td>
          {RowData.Asset.Name}
        </td>
        <td>
          {RowData.CheckedTime === null ? '-' : moment(RowData.CheckedTime).format('ll')}
        </td>
        <td className="text-center">
          {this.renderState(RowData.State)}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/job/job_stock_check/helper/component/detail/DetailRow.js